<template>


  <b-container fluid class="header" v-if="help">
    <b-jumbotron fluid>
      <h2 class='text-white'>Directories</h2>
      <p class='text-white'>Automate your online presence with managed directory listings</p>
      <b-button @click='help = !help'>Get started</b-button>
    </b-jumbotron>

    <b-container class="mt-4">
      <b-card title="Directory listings" class="mb-4">
        A major part of local SEO having acurate information on directories. We automate this process for you by adding your website to online directories and helping you keep the information up to date.
      </b-card>
      <b-card title="Locations" class="mb-4">
        Directories often point towards a single physical location e.g. an office or your store. You can add and manage multiple locations.
      </b-card>
    </b-container>
  </b-container>

  <b-container fluid v-else>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Directories</h2>
        </b-col>
        <b-col class="float-right">
          <b-button class="float-right" variant="transparent" @click="help = !help"><i class="far fa-question-circle"></i></b-button>
        </b-col>
      </b-row>
      <b-nav>
        <b-nav-item :to="{name: 'locations'}" exact exact-active-class="tab_active">Locations</b-nav-item>
        <b-nav-item :to="{name: 'site_links'}" exact exact-active-class="tab_active">Automatic</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" :site="site" />
  </b-container>
</template>

<script>

import { db } from '@/main.js'

export default {
  name: 'site_links',
  props: ['profile', 'user', 'site'],
  data() {
    return {help: this.site.help.directories}
  },
  watch: {
    help(val) {
      if (this.site.help.directories && !val) {
        db.collection('site').doc(this.site.id).update({'help.directories': false})
      }
    }
  }
}
</script>

<style scoped>

</style>
